/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useState } from 'react';

import { Col, Container, Figure, Row } from 'react-bootstrap';
import { LoaderWithProps } from '../view/MainBoard/Components/Loading';
import AppRoute from './AppRoute';
import LoaderContext from './loaderContext';
import UserContext from './userContext';


const App = ({ sessionKey, logoutConfirmation, publisherID, toggleMenu, userName, publisherName, typeOfLogin }) => {
    const [triggerLoader, handleTriggerLoader] = useState(false);

    return (<LoaderContext.Provider value={{
        triggerLoader,
        handleTriggerLoader: (trigger = null) => { handleTriggerLoader(previousVal => ('boolean' === typeof trigger ? trigger : !previousVal)) }
    }}>
        <LoaderWithProps key="LoadingScreen" />

        <Container fluid className={`${sessionKey === 'true' ? 'main_content' : 'main_section'} pe-0`}>
            {sessionKey === 'true' && <Row className="m-0">
                <Col className="p-0">
                    <div className="Header w-100 d-flex flex-row px-3 py-2">
                        <div className="pe-3 menu">
                            <a onClick={() => toggleMenu(true)}><Figure className="m-0">
                                <Figure.Image
                                    alt="Deposit"
                                    src="./images/menu.png"
                                    className="m-0"
                                />
                            </Figure></a>
                        </div>
                        <div className="w-75 d-flex align-items-center">Welcome&nbsp;<b>{userName}&nbsp;{typeOfLogin === 'CP' && (publisherName)}</b></div>
                        <div className="w-25 text-end d-flex align-items-center justify-content-end">
                            <a className="theme-font-color" onClick={() => logoutConfirmation()}>Logout</a>
                        </div>

                    </div>
                </Col>
            </Row>}

            <UserContext.Provider value={{ publisherID: publisherID }}>
                <AppRoute log_session={sessionKey} />
            </UserContext.Provider>


        </Container>
    </LoaderContext.Provider>);
}

export default App;